import React from 'react';
import SummaryFunctional from './Components/summaryFunctional';
import reducer from './reducer';
import sagas from './sagas';
import { withReducer } from '@store/reducerLoader';

const SummaryPage = ({ buttonMode, buttonName }) => {
	return <SummaryFunctional buttonMode={buttonMode} buttonName={buttonName} />;
};

const ReducedScreen = withReducer('feeInfo', reducer, sagas)(SummaryPage);
export default ReducedScreen;
